//extracted by mini-css-extract-plugin
export default {"noResultsContainer":"styles_noResultsContainer__1bv40","msgContainer":"styles_msgContainer__pPXYM"};;